import Checkbox from 'jl-design-system/components/checkbox/Checkbox';

export const PATCH_TEST = {
  patchTest: {
    component: Checkbox,
    type: 'checkbox',
    name: 'patchTest',
    id: 'ocab-patch-test',
    value: 'true',
    required: true,
    validationMessageKeys: {
      required: "Please confirm if you've had or will have the necessary patch test",
    },
  },
};

export const PATCH_TEST_CONFIG = [...Object.values(PATCH_TEST)];
